/**
 * Enum representing the internal state IDs used by the `useStepProgress` hook.
 * These keys map directly to the `id` fields in `program-master-data.json`
 * and are used to store the user's progress across the Program Generator AI flow.
 */
export enum ProgramStepId {
  ClientName = 'client_name',
  ClientBodyProfile = 'client_body_profile',
  TrainingGoal = 'training_goal',
  IncreaseStrengthFocus = 'increase_strength_focus',
  IncreaseStrengthOutcome = 'increase_strength_outcome',
  IncreaseStrengthApproach = 'increase_strength_approach',
  EnduranceType = 'endurance_type',
  EnduranceApproach = 'endurance_approach',
  PerformanceSupport = 'performance_support',
  PerformanceFocus = 'performance_focus',
  PerformanceApproach = 'performance_approach',
  GeneralFitnessMeaning = 'general_fitness_meaning',
  GeneralFitnessApproach = 'general_fitness_approach',
  InjuryPreventionArea = 'injury_prevention_area',
  InjuryPreventionFocus = 'injury_prevention_focus',
  InjuryPreventionApproach = 'injury_prevention_approach',
  RehabilitationArea = 'rehabilitation_area',
  RehabilitationStage = 'rehabilitation_stage',
  RehabilitationApproach = 'rehabilitation_approach',
  MobilityArea = 'mobility_area',
  MobilityPurpose = 'mobility_purpose',
  MobilityApproach = 'mobility_approach',
  BuildMusclePrimary = 'build_muscle_primary',
  BuildMuscleSecondary = 'build_muscle_secondary',
  BuildMuscleApproach = 'build_muscle_approach',
  WeightLossPrimary = 'weight_loss_primary',
  WeightLossSecondary = 'weight_loss_secondary',
  WeightLossTarget = 'weight_loss_target',
  WeightLossApproach = 'weight_loss_approach',
  SecondaryGoals = 'secondary_goals',
  SelectedEquipment = 'selected_equipment',
  InjuriesParts = 'injuries_parts',
  InjuriesNotes = 'injuries_notes',
  EnergyLevel = 'energy_level',
  ActivityLevel = 'activity_level',
  FitnessLevel = 'fitness_level',
  MovementInsights = 'movement_insights',
  ProgramDuration = 'program_duration',
  HowOftenTrain = 'how_often_train',
  HowOftenTrainReminder = 'how_often_train_reminder',
  WorkoutDuration = 'workout_duration',
  Intensity = 'intensity',
  ProgramName = 'program_name',
}

/**
 * Enum representing the training goal slugs from `program-master-data.json`.
 * These values strictly match the `.slug` properties defined in the master data
 * and are used to conditionally route the user to different sub-steps (e.g., Weight Loss vs Rehabilitation).
 */
export enum TrainingGoalSlug {
  IncreaseStrength = 'increase-strength',
  BuildMuscle = 'build-muscle',
  WeightLoss = 'weight-loss',
  Endurance = 'endurance',
  Mobility = 'mobility',
  Performance = 'performance',
  GeneralFitness = 'general-fitness',
  Rehabilitation = 'rehabilitation',
  InjuryPrevention = 'injury-prevention',
}
